export const experiments = {
  "checkout-newsletter-signup-text": [
    "control",
    "test1",
    "test2",
    "test3",
    "test4",
    "test5",
    "test6",
    "test7",
    "test8",
    "test9",
  ],
  "cart-sidebar-perk-position": ["control", "test"],
  "no-required-phone-number": ["control", "explained-and-required", "explained-and-optional", "optional", "removed"],
  "no-required-address-fields": ["control", "test"],
  // "show-product-category-video": ["control", "manual_play", "auto_play"], // winner: "manual_play"
  // "video-position": ["control", "below_accessories", "no_video"], // winner: "no_video"
  // "header-bollerwagen-link-bold": ["control", "test"], // winner: test
  // "checkout-like-shopify": ["control", "test"], // winner: test
  // "cart-sidebar-perk-variation": ["control", "test"], // winner: control
  // "implicit-terms-and-conditions": ["control", "test"], // winner: test
  // "no-home-about-us": ["control", "test"], // winner: control
  // "paypal-express-only-in-checkout": ["control", "test"], // winner: test
  // "discount-code-input-only-in-checkout": ["control", "test"], // winner: test
  // "fulfillment-methods-in-footer": ["control", "test"], // winner: test
  // "shop-perks-below-hero-section": ["control", "test"], // winner: test
  // "no-horizontal-accessories": ["control", "test"], // winner: test
  // "show-stars-on-product-cards": ["control", "test"], // winner: test
  // "no-sidebar-accessories": ["control", "test"], // winner: control
  // "no-video": ["control", "test"], // cancelled
  "test-experiment": ["control", "test_group_1", "test_group_2"],
} as const

export function getExperimentVariants<Key extends ExperimentKey>(key: Key) {
  return experiments[key]
}

export type Experiments = typeof experiments
export type ExperimentKey = keyof Experiments
export type ExperimentVariant<Key extends ExperimentKey> = Experiments[Key][number]
